module.exports = __webpack_public_path__ + "static/media/moto-icon.b1a4bda4.png";